module.exports = __webpack_public_path__ + "static/portfolio_gallery_17-5b2ed821f20e85a2a3d460acac3c28b9.jpg";